import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Card, Modal, Row, Col, Form, Table, Pagination, Container } from 'react-bootstrap';
import axios from 'axios';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { var_api } from '../../constant';
import Swal from "sweetalert2";
import Loader from "../Loader";


function getFormattedDate(daysBeforeToday) {
    const date = new Date();
    date.setDate(date.getDate() - daysBeforeToday);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

const MembershipList = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(25);
  const [popupLast30Days, setPopupLast30Days] = useState(false);
  const [startDate, setStartDate] = useState(getFormattedDate(30));
  const [endDate, setEndDate] = useState(getFormattedDate(0));
  const [clientsData, setClientsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  useEffect(() => {
    fetchClients();
    setCurrentPage(1);
  }, [searchQuery, startDate, endDate]);

  const fetchClients = async () => {
    try {
      setLoading(true);
      // const id = localStorage.getItem('userId');
      const formattedStartDate = formatToDDMMYY(startDate);
      const formattedEndDate = formatToDDMMYY(endDate);
      const tokens = localStorage.getItem('token');
      const response = await axios.get(`${var_api}/api/membership/list-report/${formattedStartDate}/${formattedEndDate}`, {
        headers: { Authorization: `${tokens}` }
      });
      setClientsData(response.data);
      setPopupLast30Days(false);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
      if (error.response && error.response.status === 401) {
        history.push('/signin');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response?.data?.error || 'Something went wrong!',
          confirmButtonColor: '#007500',
        });
      }
    }
  };

  const formatToDDMMYY = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    return `${day}-${month}-${year}`;
  };

  const filteredUsers = clientsData.filter((client) => {
    const name = client.cust_name ? client.cust_name.toLowerCase() : "";
    const membershipNo = client.membership_no ? client.membership_no.toLowerCase() : "";
    const mobile = client.cust_mobile ? client.cust_mobile.toLowerCase() : "";
    const serviceName = client.service_name ? client.service_name.toLowerCase() : "";
    return (
      name.includes(searchQuery.toLowerCase()) ||
      membershipNo.includes(searchQuery.toLowerCase()) ||
      mobile.includes(searchQuery.toLowerCase()) ||
      serviceName.includes(searchQuery.toLowerCase())
    );
  });

  const totalPages = Math.ceil(filteredUsers.length / pageSize);
  const paginatedUsers = filteredUsers.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  const exportTableToPDF = () => {
    const doc = new jsPDF();
    const columns = [
      "S.No", "Membership No", "Profile", "Name", "Mobile", "Transaction ID",
      "Paid Amount", "Actual Amount", "Used Amount", "Balance Amount",
      "Service Image", "Service Name", "Membership Discount", "Paid Date", "Expired Date"
    ];
    const rows = paginatedUsers.map((client, index) => [
      index + 1,
      client.membership_no,
      client.cust_profile,
      client.cust_name,
      client.cust_mobile,
      client.transaction_id,
      client.paid_amount,
      client.actual_amount,
      client.used_amount,
      client.balance_amount,
      client.service_image,
      client.service_name,
      client.membership_discount,
      client.paid_date,
      client.expired_date
    ]);

    doc.autoTable({ head: [columns], body: rows, theme: 'grid', startY: 10, styles: { fontSize: 8 } });
    doc.save('MembershipData.pdf');
  };

  const exportTableToExcel = () => {
    const data = paginatedUsers.map((client, index) => ({
      S_No: index + 1,
      Membership_No: client.membership_no,
      Profile: client.cust_profile,
      Name: client.cust_name,
      Mobile: client.cust_mobile,
      Transaction_ID: client.transaction_id,
      Paid_Amount: client.paid_amount,
      Actual_Amount: client.actual_amount,
      Used_Amount: client.used_amount,
      Balance_Amount: client.balance_amount,
      Service_Image: client.service_image,
      Service_Name: client.service_name,
      Membership_Discount: client.membership_discount,
      Paid_Date: client.paid_date,
      Expired_Date: client.expired_date
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Membership Data");
    XLSX.writeFile(workbook, 'MembershipData.xlsx');
  };

  return (
    <>
     {loading && <Loader />} 
    <Container className="activity-container mx-auto">
          <Button variant="dark" onClick={() => history.push('/reports')} className="mb-4">
            <i className='bx bx-arrow-back'></i> Back
          </Button>
          <h2 className="mb-4 text-center">Membership List</h2>
          <p className="mb-4 text-center">Comprehensive list of all active memberships.</p>

          <div className="filters mb-4 d-flex justify-content-between">
    <Button variant="dark" onClick={() => setPopupLast30Days(true)}>Date Filter</Button>
    <Form.Control
            type="text"
            placeholder="Search"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="search"
            style={{ width: '200px' }} // Adjust width as needed
        />
  </div>

          <Modal show={popupLast30Days} onHide={() => setPopupLast30Days(false)} centered>
            <Modal.Header closeButton>
              <Modal.Title>Filter Last 30 Days</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row className="mb-4">
                <Col>
                  <Form.Label>Start Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                  />
                </Col>
                <Col>
                  <Form.Label>End Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </Col>
              </Row>
              <Button variant="dark" onClick={fetchClients}>Apply</Button>
              <Button variant="outline-secondary" onClick={() => setPopupLast30Days(false)} className="ms-2">Cancel</Button>
            </Modal.Body>
          </Modal>

          {/* <div className="d-flex justify-content-end mb-4">
            <Form.Control
              type="text"
              placeholder="Search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="search"
            />
          </div> */}

          <Table responsive bordered hover>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Membership No</th>
                <th>Cust Profile</th>
                <th>Cust Name</th>
                <th>Cust Mobile</th>
                <th>Transaction ID</th>
                <th>Paid Amount</th>
                <th>Actual Amount</th>
                <th>Used Amount</th>
                <th>Balance Amount</th>
                <th>Service Image</th>
                <th>Service Name</th>
                <th>Membership Discount</th>
                <th>Paid Date</th>
                <th>Expired Date</th>
              </tr>
            </thead>
            <tbody>
              {paginatedUsers.length > 0 ? (
                paginatedUsers.map((client, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{client.membership_no}</td>
                    <td><img src={`${var_api}/${client.cust_profile}`} alt="Profile" className="profile-image" width='65px' height='65px' /></td>
                    <td>{client.cust_name}</td>
                    <td>{client.cust_mobile}</td>
                    <td>{client.transaction_id}</td>
                    <td>{client.paid_amount}</td>
                    <td>{client.actual_amount}</td>
                    <td>{client.used_amount}</td>
                    <td>{client.balance_amount}</td>
                    <td><img src={`${var_api}/${client.service_image}`} alt="Profile" className="profile-image" width='65px' height='65px' /></td>
                    <td>{client.service_name}</td>
                    <td>{client.membership_discount}</td>
                    <td>{client.paid_date}</td>
                    <td>{client.expired_date}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="15" className="text-center">No Data Available</td>
                </tr>
              )}
            </tbody>
          </Table>
          <div className='d-flex justify-content-between align-items-center mt-4'>

          <div className="d-flex justify-content-start mt-4">
            <Button onClick={exportTableToPDF} variant="dark">Download as PDF</Button>
            <Button onClick={exportTableToExcel} variant="dark" className="ms-2">Download as Excel</Button>
          </div>
          <Pagination className="mt-0">
            <Pagination.Prev onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}>Previous</Pagination.Prev>
            {[...Array(totalPages).keys()].map((_, idx) => (
              <Pagination.Item key={idx} active={currentPage === idx + 1} onClick={() => setCurrentPage(idx + 1)}>
                {idx + 1}
              </Pagination.Item>
            ))}
            <Pagination.Next onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}>Next</Pagination.Next>
          </Pagination>
          </div>
    </Container>
    </>
  );
};

export default MembershipList;
